import type { Pretensao } from "@/api/db/connection";

export type { Pretensao };

export const PRETENSAO_OUTRO: Pretensao = "outro";

export const pretensaoLabel: Record<Pretensao, string> = {
	abdomen: "Abdome",
	lipo: "Lipoaspiração / Lipoescultura",
	mama: "Mama",
	botox: "Botox / Toxina",
	preenchimento: "Preenchimento / Bioestimulador",
	rinoplastia: "Rinoplastia",
	gluteo: "Glúteo",
	outro: "Outro",
};

export const pretensaoOrder: Pretensao[] = [
	"abdomen",
	"lipo",
	"mama",
	"botox",
	"preenchimento",
	"rinoplastia",
	"gluteo",
	"outro",
];
